import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { AuthUser } from '@/contexts/AuthContext';

interface AuthState {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  // Called by AuthSync to keep store in sync with AuthContext
  _setUser: (user: AuthUser | null) => void;
  _setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      user: null,
      isAuthenticated: false,
      isLoading: true,
      _setUser: (user) => set({ user, isAuthenticated: user !== null }),
      _setLoading: (isLoading) => set({ isLoading }),
    }),
    { name: 'auth' },
  ),
);
